import React, {useDebugValue} from 'react';

import classNames from 'classnames';

import {useSearchFormContext} from '../../../hooks/useSearchFormContext';
import {useTrackingContext} from '../../../hooks/useTrackingContext';

import {undef} from '../../../utils/undef';
import {triggerDestinationSummaryClickEdapEvent} from '../../../utils/edap';
import {getGuestsFieldInputLabel} from '../../../utils/guests';
import {getDatesSummaryLabelForCollapsedSearchForm} from '../../../utils/dates';

import {SVGIcon} from '@homeaway/react-svg';
import {EDIT__16} from '@homeaway/svg-defs';

const classNamespace = 'search-form';
const fieldClassName = `${classNamespace}__field`;
const inputFieldClassName = `${classNamespace}__input-field`;
const summaryFieldClassName = `${classNamespace}__summary-field`;
const summaryInputFieldClassName = `${classNamespace}__summary-input-field`;
const destinationSummaryInputFieldClassName = `${classNamespace}__destination-summary-input-field`;
const destinationSummaryInputFieldNoButtonClassName = `${classNamespace}__destination-summary-input-field-no-button`;

function useComponent() {
    const {
        edapOptions,
        systemOptions,
        detailsModalActions: {
            setIsOpen: setIsDetailsModalOpen
        },
        translations,
        translations: {
            placeholderMessage,
            addDates,
            addGuests
        },
        latestDestinationValues: {
            destination
        },
        latestDatesValues: {
            startDate,
            endDate
        },
        latestGuestsValues,
        latestGuestsValues: {
            adultsCount,
            childrenCount,
            petIncluded
        },
        destinationSummaryEvents: {
            onClick: onDestinationSummaryClick
        }
    } = useSearchFormContext();

    const trackingContext = useTrackingContext();
    const {locale} = systemOptions;

    let dateString = addDates;
    let guestString = addGuests;
    let label = placeholderMessage;
    let chooseClassNames = classNames(fieldClassName, inputFieldClassName, summaryFieldClassName, summaryInputFieldClassName, destinationSummaryInputFieldClassName, destinationSummaryInputFieldNoButtonClassName);
    if (startDate !== '' && endDate !== null) {
        chooseClassNames = classNames(chooseClassNames, 'has-dates');
        dateString = getDatesSummaryLabelForCollapsedSearchForm(startDate, endDate, locale);
    }
    if (adultsCount + childrenCount + petIncluded !== 0) {
        chooseClassNames = classNames(chooseClassNames, 'has-guests');
        guestString = getGuestsFieldInputLabel(translations, latestGuestsValues);
    }
    if (destination) {
        chooseClassNames = classNames(chooseClassNames, 'has-destination');
        label = destination;
    }

    const className = chooseClassNames;

    const id = 'search-destination-summary-details';
    const rightContent = <SVGIcon className="text-info" markup={EDIT__16} />;
    const handleFocus = undef;

    function handleClick(...args) {
        triggerDestinationSummaryClickEdapEvent(trackingContext, edapOptions);

        setIsDetailsModalOpen(true);

        onDestinationSummaryClick(...args);
    }

    const handleKeyPress = undef;

    const result = {
        className,
        id,
        label,
        rightContent,
        handleClick,
        handleKeyPress,
        handleFocus,
        dateString,
        guestString
    };

    useDebugValue(result);
    return result;
}

export {useComponent};
